import {
  faGlobeAmericas,
  faPlus,
  faSave,
  faTimes } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef, Fragment } from "react";
import { useHistory } from "react-router";
import GetStudentService from "../../../../services/SchoolIT/GetStudentService";
import AppHeader from "../../../../Layout/AppHeader";
import AppSidebar from "../../../../Layout/AppSidebar";
import CustomLoader from "../../../customLoader/CustomLoader";
import "../../../admin/StudentProgress/StudentProgress.css";
import "../GoalCriteriaOrSetup.css";

const MapGoal = () => {
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [deletedGoal, setDeletedGoal] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [criteria, setCriteria] = useState([]);
  const [goalFieldTypes, setGoalFieldTypes] = useState([]);
  const [dataSourceType, setDataSourceType] = useState([]);
  const [dataSourceColumnOption1, setDataSourceColumnOption1] = useState([]);
  const [dataSourceColumnOption2, setDataSourceColumnOption2] = useState([]);
  const [goalFieldName, setGoalFieldName] = useState([]);
  const [fieldTypes, setFieldTypes] = useState([]);
  const [arithemeticOperator, setArithemeticOperator] = useState([]);
  const [disableGoalElement, setDisableGoalElement] = useState(1);
  const goalNameRef = useRef();
  // const literalGoalFieldRef = useRef();
  const dataSourceRef = useRef();
  const arithemeticOperatorRef = useRef();

  const getGoalFieldTypes = () => {
    setLoading(true);
    GetStudentService.getGoalFieldTypes()
    .then((data) => {
      setLoading(false);
      setGoalFieldTypes(data.data.objects);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const getArithemeticOperators = () => {
    setLoading(true);
    GetStudentService.getArithemeticOperator()
    .then((data) => {
      setLoading(false);
      setArithemeticOperator(data?.data?.objects);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const getDataSource = () => {
    setLoading(true);
    GetStudentService.getDataSrc(user?.school_id)
    .then((data) => {
      setLoading(false);
      let arr = data?.data?.objects;
      arr.map((item) => getDataSourceCol(item?.id));
      setDataSourceType(data?.data?.objects);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const getDataSourceCol = (id) => {
    setLoading(true);
    GetStudentService.getDataSrcCol(id)
    .then((data) => {
      setLoading(false);
      if (id === 18) setDataSourceColumnOption1(data?.data?.objects);
      if (id === 19) setDataSourceColumnOption2(data?.data?.objects);
      // setDataSourceColumnOption(data?.data?.objects);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const getFieldTypes = () => {
    setLoading(true);
    GetStudentService.getFieldTypes()
    .then((data) => {
      setFieldTypes(data?.data?.objects);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const getGoalFieldNames = () => {
    setLoading(true);
    GetStudentService.goalFieldForCreateGoal(user?.school_id)
    .then((data) => {
      setGoalFieldName(data?.data?.objects);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const getMapList = () => {
    setLoading(true);
    GetStudentService.mapList({ school: user?.school_id })
    .then((data) => {
      let array = [];
      let dataObject = data?.data;
      if (Object.keys(dataObject).length > 0) {
        for (let key in dataObject) {
          let obj = {
            data: dataObject[key]?.goalfieldmap?.field_data?.goal_value,
            datasource: dataObject[key]?.goalfieldmap?.datasource_id,
            datacolumn: dataObject[key]?.goalfieldmap?.mapping_column_id,
            goal_type: dataObject[key]?.goalfieldmap?.goalfield_type_id,
            goal1: dataObject[key]?.goalfieldmap?.field_data?.goal_data1_id,
            goal2: dataObject[key]?.goalfieldmap?.field_data?.goal_data2_id,
            operator: dataObject[key]?.goalfieldmap?.field_data?.operator_id,
            goalname: dataObject[key].field_name,
            goalid: dataObject[key].id,
            is_global: dataObject[key]?.is_global,
            datatype: dataObject[key]?.goalfieldmap?.datatype_id,
            mapid: dataObject[key]?.goalfieldmap.id
          };
          if (dataObject[key]?.goalfieldmap?.field_data) {
            obj.datatype =
            dataObject[key]?.goalfieldmap?.field_data?.goal_datatype_id;
          }
          array.push(obj);
        }
      }
      setDisableGoalElement(array.length);
      setCriteria(array);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  useEffect(() => {
    getMapList();
    getGoalFieldTypes();
    getGoalFieldNames();
    if (user?.school_id) {
      getDataSource();
    }
    getArithemeticOperators();
    getFieldTypes();
  }, []);

  const saveGoalMap = () => {
    setLoading(true);
    let arr = criteria;
    if (deletedGoal.length > 0) {
      arr = [...arr, ...deletedGoal];
    }
    let obj = {
      map_values: [null, ...arr],
      school_id: user?.school_id
    };
    GetStudentService.saveGoalMap(obj)
    .then((_data) => {
      setLoading(false);
      history.push("/school_it/ccplus");
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const removeCriteria = (index, item) => {
    if (index < disableGoalElement) {
      let obj = {
        map_values: item.goalid,
        school_id: user?.school_id
      };
      setLoading(true);
      GetStudentService.removeGoalMap(obj)
      .then((_data) => {
        setDisableGoalElement(disableGoalElement - 1);
        criteria.splice(index, 1);
        setCriteria([...criteria]);
        item.goalid = `${obj.map_values}-D`;
        setDeletedGoal([...deletedGoal, item]);
        setLoading(false);
      })
      .catch((_error) => {
        setLoading(false);
      });
    } else {
      criteria.splice(index, 1);
      setCriteria([...criteria]);
    }
  };

  const AddNewCriteria = () => {
    let array = [];
    // let itemNo = criteria.length + 1;
    let data = {
      datasource: "",
      datacolumn: "",
      goal_type: "",
      goal1: "",
      goal2: "",
      operator: "",
      data: "",
      goalname: "",
      goalid: "",
      datatype: "",
      mapid: ""
    };
    array.push(data);
    setCriteria([...criteria, ...array]);
  };

  const handleGoalNameChange = (index) => {
    criteria[index].goalname = goalNameRef.current.value;
    setCriteria([...criteria]);
  };

  const handleGoalFieldRef = (e, index) => {
    criteria[index].goal_type = parseInt(e.target.value);
    setCriteria([...criteria]);
  };

  const handleDataSourceChange = (index) => {
    criteria[index].datasource = dataSourceRef.current.value;
    criteria[index].datacolumn = "";
    setCriteria([...criteria]);
    // getDataSourceCol(dataSourceRef.current.value);
  };

  const handleDataColumn = (e, index) => {
    criteria[index].datacolumn = e.target.value;
    setCriteria([...criteria]);
  };

  const handleGoal1Change = (e, index) => {
    criteria[index].goal1 = e.targer.value;
    setCriteria([...criteria]);
  };

  const handleGoal2Change = (e, index) => {
    criteria[index].goal2 = e.target.value;
    setCriteria([...criteria]);
  };

  const handleLiteralGoalFieldDataChange = (e, index) => {
    criteria[index].data = e.target.value;
    setCriteria([...criteria]);
  };

  const handleArithemeticOperatorChange = (index) => {
    criteria[index].operator = arithemeticOperatorRef.current.value;
    setCriteria([...criteria]);
  };

  const handleFieldTypeChange = (e, index) => {
    criteria[index].datatype = e.target.value;
    setCriteria([...criteria]);
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          {loading ?
          <CustomLoader /> :

          <div className="admin-ccplus-page">
              <div className="admin-ccplus-header">
                <div>
                  <h1 className="admin-ccplus-title">Map School Goal Data</h1>
                  <p className="admin-ccplus-subtitle">
                    Map goal elements to school data sources and field types
                  </p>
                </div>
                <div className="admin-ccplus-header-actions">
                  <button
                  type="button"
                  className="admin-ccplus-btn ghost toolbar"
                  onClick={() => history.push("/school_it/ccplus")}>

                    Back
                  </button>
                </div>
              </div>

              <div className="admin-ccplus-form-card school-it-map-form">
              <div className="school-it-map-goal-headers">
                <p>Goal Elements</p>
                <p>Type</p>
              </div>
              {criteria &&
              criteria.length > 0 &&
              criteria.map((item, index) =>
              <div
                key={index}
                className="school-it-map-goal-row">

                    {item?.is_global ?
                <div style={{ margin: "0 15px" }}>
                        <FontAwesomeIcon
                    icon={faGlobeAmericas}
                    size="2x"
                    color="#1395f2" />

                      </div> :

                <button
                  type="button"
                  onClick={() => removeCriteria(index, item)}
                  className="admin-create-goal-remove-btn"
                  style={{ margin: "0 15px" }}>

                        <FontAwesomeIcon icon={faTimes} />
                      </button>}


                    <input
                  className="admin-course-set-input school-it-map-goal-field"
                  ref={goalNameRef}
                  type="text"
                  placeholder="Enter New Goal Element"
                  value={item.goalname}
                  onChange={() => handleGoalNameChange(index)}
                  disabled={item.is_global || index < disableGoalElement} />


                    <select
                  className="admin-course-set-input school-it-map-goal-field"
                  onChange={(e) => handleGoalFieldRef(e, index)}
                  value={item.goal_type}>

                      <option>Select Type</option>
                      {goalFieldTypes?.map((item1, _index) =>
                  <option value={parseInt(item1?.id)}>
                          {item1?.goalfield_name}
                        </option>
                  )}
                    </select>

                    {item.goal_type === 1 &&
                <>
                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    ref={dataSourceRef}
                    value={item.datasource}
                    onChange={() => handleDataSourceChange(index)}>

                          {dataSourceType?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                              {item1?.name}
                            </option>
                    )}
                        </select>

                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    onChange={(e) => handleDataColumn(e, index)}
                    value={item.datacolumn}>

                          <option>Select Data Column</option>
                          {item.datasource == 18 &&
                    dataSourceColumnOption1?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                                {item1?.column_name}
                              </option>
                    )}
                          {item.datasource == 19 &&
                    dataSourceColumnOption2?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                                {item1?.column_name}
                              </option>
                    )}
                        </select>

                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    value={item.datatype}
                    onChange={(e) => handleFieldTypeChange(e, index)}>

                          <option>Select Data Format</option>
                          {fieldTypes?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                              {item1?.field_type}
                            </option>
                    )}
                        </select>
                      </>}


                    {item.goal_type === 2 &&
                <>
                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    value={item.goal1}
                    onChange={(e) => handleGoal1Change(e, index)}>

                          <option>Select Goal Field</option>
                          {goalFieldName?.map((item1, index1) => {
                      if (index1 !== index)
                      return (
                        <option value={parseInt(item1?.id)}>
                                  {item1?.field_name}
                                </option>);

                    })}
                        </select>

                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    onChange={() =>
                    handleArithemeticOperatorChange(index)}

                    value={item.operator}
                    ref={arithemeticOperatorRef}>

                          <option>Select Operator</option>
                          {arithemeticOperator?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                              {item1?.operator}
                            </option>
                    )}
                        </select>

                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    value={item.goal2}
                    onChange={(e) => handleGoal2Change(e, index)}>

                          <option>Select Goal Field</option>
                          {goalFieldName?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                              {item1?.field_name}
                            </option>
                    )}
                        </select>
                      </>}


                    {item.goal_type === 3 &&
                <>
                        <input
                    className="admin-course-set-input school-it-map-goal-field"
                    type="text"
                    placeholder="--Enter Data--"
                    onChange={(e) =>
                    handleLiteralGoalFieldDataChange(e, index)}

                    value={item.data} />


                        <select
                    className="admin-course-set-input school-it-map-goal-field"
                    value={item.datatype}
                    onChange={(e) => handleFieldTypeChange(e, index)}>

                          <option>Select Data Format</option>
                          {fieldTypes?.map((item1, _index) =>
                    <option value={parseInt(item1?.id)}>
                              {item1?.field_type}
                            </option>
                    )}
                        </select>
                      </>}

                  </div>
              )}

              <div className="admin-create-goal-add-criteria">
                <button
                  type="button"
                  className="admin-ccplus-btn secondary"
                  onClick={AddNewCriteria}>

                  <FontAwesomeIcon icon={faPlus} />
                  Add New Goal Field
                </button>
              </div>

              <div className="admin-ccplus-form-actions">
                <button
                  type="button"
                  className="admin-ccplus-btn primary"
                  onClick={saveGoalMap}>

                  <FontAwesomeIcon icon={faSave} />
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => history.push("/school_it/ccplus")}
                  className="admin-ccplus-btn ghost">

                  <FontAwesomeIcon icon={faTimes} />
                  Cancel
                </button>
              </div>
              </div>
            </div>}

        </div>
      </div>
    </Fragment>);

};
export default MapGoal;